import { render } from "./ReferenceUserDetails.vue?vue&type=template&id=21aa0c60&scoped=true"
import script from "./ReferenceUserDetails.vue?vue&type=script&lang=js"
export * from "./ReferenceUserDetails.vue?vue&type=script&lang=js"

import "./ReferenceUserDetails.vue?vue&type=style&index=0&id=21aa0c60&scoped=true&lang=scss"

import exportComponent from "F:\\ei-projects\\ei-adult-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21aa0c60"]])

export default __exports__